import React, { Component } from 'react';
import PropTypes from 'prop-types';
import humps from 'humps';
import Close from '@material-ui/icons/Close';

import './EnhancedAdExample.scss';
import http from '../../shared/http';
import Mixpanel from '../../shared/Mixpanel';

class EnhancedAdExample extends Component {
  constructor(props) {
    super(props);

    this.state = {
      advertiser: ''
    };

    this.handleCloseClick = this.handleCloseClick.bind(this);
  }

  componentDidMount() {
    http
      .get(`/creative_previews/${this.props.$state.params.id}.json`)
      .then(({ data }) => {
        this.setState({
          advertiser: data.advertiser
        });
        this.props.CreativeService.setCreative(humps.camelizeKeys(data));
      })
      .catch(err => console.error(err)); // eslint-disable-line no-console

    Mixpanel.track('Show standalone example on mobile');
  }

  handleCloseClick() {
    window.location.href = '';
  }

  render() {
    return (
      <div className="example-navbar_wrapper">
        <div className="example-navbar_advertiser">{this.state.advertiser}</div>
        <Close
          className="example-navbar_close-icon"
          onClick={this.handleCloseClick}
        />
      </div>
    );
  }
}

EnhancedAdExample.propTypes = {
  $state: PropTypes.shape({
    params: PropTypes.object
  }).isRequired,
  CreativeService: PropTypes.shape({
    setCreative: PropTypes.func
  }).isRequired
};

export default EnhancedAdExample;
